import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "src/environments/environment";
import * as moment from "moment";
import { AuthenticateService } from "../authentication/authenticate.service";
import { HttpHeaders } from "@angular/common/http";
import { Observable, BehaviorSubject, forkJoin } from "rxjs";
import { tap, catchError, map } from "rxjs/operators";
import { StorageService } from "../storage/storage.service";
import { MessageCardService } from "../message/message-card.service";
@Injectable({
  providedIn: "root",
})
export class DocumentService {
  public documentBehavior = new BehaviorSubject([]);

  public uploadEvent = new BehaviorSubject({} as UploadEvent);

  constructor(
    private baseService: BaseService,
    private authenticateService: AuthenticateService,
    private messageCardService: MessageCardService,
    private storageService: StorageService
  ) {}

  getDocument(documentId: string): Observable<Document> {
    const user = this.authenticateService.user;
    const patientId = user.patientProfile.id;
    const url = `${environment.serviceURL}/v1/documents/${documentId}`;

    return this.baseService.get(url).pipe(
      tap(async (res) => {
        if (res) {
        }
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
  }
  // get all documents of a Patient
  getDocuments() {
    const user = this.authenticateService.user;
    const patientId = user.patientProfile.id;

    const url = `${environment.serviceURL}/v1/documents/patients/${patientId}`;
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.baseService.getWithHeader(url, headers).pipe(
      tap(async (res) => {
        if (res) {
          let docs = res;
          let docMap = new Map();
          docs = docs.filter(function (item, pos, array) {
            return (
              array
                .map(function (mapItem) {
                  return mapItem["id"];
                })
                .indexOf(item["id"]) === pos
            );
          });
          docs.forEach((item, index) => {
            item.url = this._checkHttps(item.url);
            // item.thumbnail = this._checkHttps(item.thumbnail);

            let docsPerType = docMap.get(item.type);
            if (!docsPerType) {
              docsPerType = [];
            }
            docsPerType.push(item);
            docMap.set(item.type, docsPerType);
          });

          let documentsArr = [];
          let iterator = docMap.keys();
          let result = iterator.next();
          while (!result.done) {
            let docType = result.value;
            let childDocs = docMap.get(docType);
            let images = childDocs.filter((doc) => {
              return doc.format == 1 || doc.format == 2 || doc.format == 3;
            });
            let pdfs = childDocs.filter((doc) => {
              return doc.format == 4;
            });
            let audios = childDocs.filter((doc) => {
              return doc.format == 5;
            });
            let videos = childDocs.filter((doc) => {
              return doc.format == 6;
            });
            let document = {
              title: childDocs[0].typeTitle,
              type: childDocs[0].type,
              count: childDocs.length,
              pdfs: pdfs,
              images: images,
              audios: audios,
              videos: videos,
            };

            documentsArr.push(document);

            result = iterator.next();
          }

          res.docArr = documentsArr;
        }
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
  }

  uploadDocument(file: File, fileName: string, document: Document) {
    const user = this.authenticateService.user;
    const documentRequest = new FormData();
    document.patientId = user.patientProfile.id;

    let documentJSON: any = {};
    documentJSON.id = document.id;
    documentJSON.patientId = user.patientProfile ? user.patientProfile.id : -1;
    documentJSON.title = fileName;
    documentJSON.description = document.description;
    documentJSON.type = document.type;
    documentJSON.format = document.format;
    documentJSON.status = document.status;

    documentRequest.append("file", file);

    documentRequest.append("fileName", fileName);
    documentRequest.append("document", JSON.stringify(documentJSON));

    documentRequest.append("patientPhoneNo", `${user.phoneNo}`);

    documentRequest.append("patientId", `${user.patientProfile.id}`);

    const documentUploadURL = `${environment.serviceURL}/v1/documents`

    this.baseService.postWithForm(documentUploadURL, documentRequest).subscribe(
      (res) => {
        this.handleUploadSuccess(res);
      },
      (err) => {
        this.handleUploadFailure("Something went wrong.");
      }
    );
  }

  handleUploadFailure(err) {
    this.uploadEvent.next({
      loading: false,
      blob: undefined,
      error: true,
      msg: err,
    });
  }
  handleUploadSuccess(res) {
    this.uploadEvent.next({
      loading: false,
      blob: undefined,
      error: false,
      msg: "",
    });
    this.messageCardService.sendDocumentCard(res);
  }
  buildAndUpload(e) {
    const file = e.target.files[0];
    const fileName = file.name;
    if (file.size > 20000000) {
      this.handleUploadFailure("File size should be less than 20MB");
      return;
    }

    const document = {
      id: "",
      title: "",
      description: "",
      url: "",
      type: 6,
      format: 1,
      status: 4,
      thumbnail: "",
      patientId: 0,
      typeTitle: "",
      createdAt: undefined,
    } as Document;
    if (file.type === "image/jpg" || file.type === "image/jpeg") {
      document.format = 1;
    } else if (file.type === "image/png") {
      document.format = 2;
    } else if (file.type === "image/gif") {
      document.format = 3;
    } else if (file.type === "application/pdf") {
      document.format = 4;
    } else if (file.type === "audio/mp3") {
      document.format = 5;
    } else if (file.type === "video/mp4") {
      document.format = 6;
    } else {
      this.handleUploadFailure("Unsupported File");
      return;
    }
    this.uploadDocument(file, fileName, document);
  }
  getToken(): Observable<DocToken> {
    let token: DocToken;
    return this.storageService.get("token").pipe(
      tap(async (res) => {
        if (res && res.expiredTime > moment.utc().valueOf()) {
          token = res.token;
        } else {
          this._generateToken().subscribe((token1) => {
            token = token1;
          });
          return token;
        }
      })
    );
  }
  _generateToken(): Observable<DocToken> {
    const url = `${environment.apiURL}/documents/token/generate`;
    return this.baseService.get(url).pipe(
      tap(async (res) => {
        this.storageService.set("token", res);
        return res;
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
    // return this.storageService.get('TOKEN')
  }
  getUrlWithToken(url, token) {
    if (url && url.indexOf("?") != -1) {
      url = `${url}&token=${token}`;
    } else {
      url = `${url}?token=${token}`;
    }
    return url;
  }
  _checkHttps(url) {
    let httpsURL = url;
    if (url && !url.includes("https")) {
      httpsURL = "https".concat(url.slice(4));
    }

    // httpsURL = httpsURL.replace(
    //   "staging.fs.zyla.in/",
    //   "staging.abhi.zyla.in/docs/"
    // );
    // httpsURL = httpsURL.replace(
    //   "fs.zyla.in/",
    //   environment.isExternalPwa ? "abhi.zyla.in/docs/" : "m1.abhi.zyla.in/docs/"
    // );
    return httpsURL;
  }
}
export interface DocToken {
  token: string;
  expiredTime: number;
}

export interface Content {
  contentS3Path: string;
  createdAt: string;
  description: string;
  fileName: string;
  id: string;
  orginalFileName: string;
  publicUrl: string;
  thumbnailUrl: string;
  thumbFileName: string;
  thumbURL: string;
  updatedAt: string;
}
export interface Document {
  description: string;
  createdAt: number;
  format: number;
  id: string;
  patientId: number;
  status: number;
  thumbnail: string;
  title: string;
  type: number;
  typeTitle: string;
  url: string;
  updatedAt: string;
  userId: string;
}

export interface DocumentFolder {
  count: number;
  images: Array<Document>;
  pdfs: Array<Document>;
  type: number;
  title: string;
}

export interface UploadEvent {
  blob: Blob;
  loading: boolean;
  error: boolean;
  msg: string;
}
